const CreditReportTerms =
  'I confirm that I am authorised to submit this application and give Propell permission to access a consumer and company credit reports'

export default CreditReportTerms
